import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n'; // Import to initialize i18next
import { Suspense } from 'react';



// 1. Create a client
const queryClient = new QueryClient();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>

    <Suspense fallback="Loading..."> {/* Add Suspense for async translation loading */}

      {/* 2. Provide the client to your App */}
      <QueryClientProvider client={queryClient}>

        <App />

        {/* 3. (Optional but recommended) add the devtools */}
        <ReactQueryDevtools initialIsOpen={false} />
        
      </QueryClientProvider>

    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
